import * as Api from "@api";
import { State } from "../";
import { ActionType } from "../types";
import { ThunkAction } from "redux-thunk";
import { Role, RolesAction } from "../types/roles";

function getRolesRequest(key: string): RolesAction {
  return {
    type: ActionType.GET_ROLES_REQUEST,
    key,
  };
}

function getRolesSuccess(key: string, roles: Role[]): RolesAction {
  return {
    type: ActionType.GET_ROLES_SUCCESS,
    key,
    roles,
  };
}

function getRolesFailure(key: string, error: any): RolesAction {
  return {
    type: ActionType.GET_ROLES_FAILURE,
    key,
    error,
  };
}

export function getRoles(
  application: number,
  environment: string
): ThunkAction<void, State, unknown, RolesAction> {
  return async (dispatch, getState) => {
    const { network } = getState();
    const key = `${application}:${environment}`;

    if (!network.fetching.environments[key]) {
      dispatch(getRolesRequest(key));
      try {
        const roles = await Api.getRoles(application, environment);

        dispatch(getRolesSuccess(key, roles));
      } catch (error) {
        dispatch(getRolesFailure(key, error));
      }
    }
  };
}
